import { apiGet, apiPost, apiPut, apiDelete } from '.';
import { BareGroupEvent, GroupEvent, NewGroupEvent } from '../../../shared/types/groupEvent';
import { Property } from '../../../shared/types/property';
import { VenueTemplate } from '../../../shared/types/venueTemplate';
import { Time } from '../../../shared/types/time';
import { dateToIsoUTC } from '../../../shared/lib/time';

/**
 * Like a GroupEvent, but some fields have not been set yet
 *
 */
export interface EditedGroupEvent {
  _id: string;
  title: string;
  group: string;
  description: string;
  venue?: VenueTemplate;
  date?: Date;
  startTime?: Time;
  duration: number;
  property: Property;
}

export async function getGroupEvents(
  propertyId: string,
  since?: Date,
  until?: Date
): Promise<BareGroupEvent[]> {
  let queryParams: any = {};
  if (since) queryParams.from = dateToIsoUTC(since);
  if (until) queryParams.to = dateToIsoUTC(until);

  let bareGroupEvents = await apiGet<BareGroupEvent[]>(
    `/property/${propertyId}/group-event`,
    queryParams
  );
  return bareGroupEvents.map(bareGroupEvent => {
    return {
      ...bareGroupEvent,
      date: new Date(bareGroupEvent.date), // `bareGroupEvent.date` is really a string
    };
  });
}

export async function create(groupEvent: NewGroupEvent): Promise<BareGroupEvent> {
  return apiPost(`/property/${groupEvent.property}/group-event`, groupEvent);
}

export async function update(groupEvent: BareGroupEvent): Promise<BareGroupEvent> {
  return apiPut(`/property/${groupEvent.property}/group-event`, groupEvent);
}

export async function remove(groupEvent: BareGroupEvent): Promise<BareGroupEvent> {
  return apiDelete(`/property/${groupEvent.property}/group-event/${groupEvent._id}`);
}

export function populate(
  bareGroupEvent: BareGroupEvent,
  property: Property,
  venueTemplates: VenueTemplate[]
): GroupEvent {
  let venue = venueTemplates.find(vt => vt._id === bareGroupEvent.venue);
  if (!venue) {
    throw new Error(`Could not find venue ${bareGroupEvent.venue}`);
  }

  return {
    ...bareGroupEvent,
    venue,
    property,
  };
}

export function bare(groupEvent: GroupEvent): BareGroupEvent {
  return {
    ...groupEvent,
    venue: groupEvent.venue._id,
    property: groupEvent.property._id,
  };
}

export function editedGroupEventToGroupEvent(editedGroupEvent: EditedGroupEvent): GroupEvent {
  if (!editedGroupEvent.venue) throw new Error(`Missing venue`);
  if (!editedGroupEvent.date) throw new Error(`Missing date`);
  if (!editedGroupEvent.startTime) throw new Error(`Missing start time`);

  return editedGroupEvent as GroupEvent;
}
